import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

const BASE            = `${config.API_URL}ActivityPerformance`;
const BASE_KPI_CONFIG = `${config.API_URL}ActivityPerformanceKpiConfig`;
const BASE_KPI_DATA   = `${config.API_URL}ActivityPerformanceKpiData`;

export const searchActivities = ({ search, technology, vendor, team, isActive, status, page = 1, pageSize = 50 }) =>
	AxiosRequest({ method: 'GET', url: BASE, params: { search, technology, vendor, team, isActive, status, page, pageSize } });

export const getPickerOptions = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/picker-options` });

export const getActivityDetail = (id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/${id}` });

export const getActivityFilterOptions = (id, filters = {}) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/${id}/filter-options`, data: { activityId: id, ...filters } });

export const getActivityPhases = (id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/${id}/phases` });

export const getKpiConfig = () =>
	AxiosRequest({ method: 'GET', url: BASE_KPI_CONFIG });

export const getKpiConfigByTech = (tech) =>
	AxiosRequest({ method: 'GET', url: `${BASE_KPI_CONFIG}/${tech}` });

export const getKpiBatch = (charts) =>
	AxiosRequest({ method: 'POST', url: `${BASE_KPI_DATA}/batch`, data: { charts } });